import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Links from "utils/consts/links";

const PrivateRoute = (props) => {
  const { currentUser, loading, component: Component, roles, permission = true, ...rest } = props;

  const isAllowed = (
    (currentUser && permission && (!roles || roles.includes(currentUser.role)))
    || loading
  );
  let pathname = Links.LOGIN;
  if (currentUser && roles && !roles.includes(currentUser.role)) {
    pathname = Links.HOME;
  }

  return (
    <Route
      {...rest}
      {
      ...(!rest.children) ? //Meio pra remover warning [Não pode haver children e render ao mesmo tempo em Route]
        ({
          render: renderProps => (
            isAllowed ?
              <Component {...renderProps} />
              : (<Redirect to={{ pathname, state: { from: renderProps.location.pathname } }} />)
          )
        }) : {}
      }
    />
  );
};

const mapStateToProps = state => {
  return {
    currentUser: state.session.currentUser,
  }
}

export default connect(mapStateToProps, null)(PrivateRoute);
